import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  getNoAuthCallParams,
  makeCall,
} from "../../../../utils/service";

export async function getAllLeads(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.LEADDATA +
      // `?start_date=${payload.start_date || ""}&end_date=${payload.end_date || ""}&id=${payload.userId}&page=${payload.pageNo}&limit=${payload.pageSize}&searchUserId=${payload.lead_id}`,

        `?start_date=${payload.startDate || ""}&end_date=${payload.endDate || ""}&id=${payload.userId}&page=${payload.pageNo}&limit=${payload.pageSize}&teamId=${payload.team_id || ""}&formId=${payload.formId || ""}&stage=${payload.stage}&source=${payload.source || ""}&search=${payload.search || ""}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDateWiseLead(
  userId: string,
  from: string,
  to: string,
  pageNo: any,
  pageSize: any
) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.LEADDATA +
        `?start_date=${from}&end_date=${to}&id=${userId}&page=${pageNo}&limit=${pageSize}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllForms() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLLEADS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getFormByID(id:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETALLLEADS}/${id}`, callParams);

    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTeamData(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETTEAMDROP}/${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTeamMembersData(payload: any) {
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(`${urls.GETMEMBERSDROP}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTeam() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETTEAMDROP}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllStage() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLSTAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllSource() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLSOURSE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getReminder(id: any) {
  
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETREMINDER}${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getReminderData() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETREMINDERALL, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function postOfficeDetails() {
  try {
    const callParams = await getCallParams("POST");
    const response = await makeCall(urls.ADDUSEROFFICE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}

export async function changeStatusApi(status: any, userId: any) {
  const payload = {
    id: userId,
    status: status == 0 ? 1 : 0,
  };
  try {
    const callParams = await getCallParams("PUT", payload);
    const response = await makeCall(urls.USERUPDATE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function deleteReminder(userId: any) {
  const payload = {
    id: userId,
    status: 0,
  };
  try {
    const callParams = await getCallParams("PUT", payload);
    const response = await makeCall(urls.DELETEREMARK, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function changeStage(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATESTAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function changeAt(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEAI, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function saveReminder(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.UPDATEREMINDER, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function assignToMembers(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.ASSIGNTOMEMBERS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllReminder(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.UPDATEREMINDER + `/${id?.id}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}


export async function getAllLeadHistory(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETLEADHISTORY + id, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}


export async function getDownloadLeads() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.DOWNLOADSLEADS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDownloadLeadsExcle(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    // const response = await makeCall(urls.DOENLOADSLEADSEXCEL, callParams);
    const response = await makeCall(
      urls.DOENLOADSLEADSEXCEL +
        `?start_date=${payload.startDate || ""}&end_date=${payload.endDate || ""}&formId=${payload.formId || ""}`,
      callParams
    );
    
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getOfficeDetails(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEEOFFICEDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
